module.exports = __webpack_public_path__ + "static/media/listening_image1.d06b006e.webp";